export const changeLocale = data => ({
  type: LocaleActions.CHANGE_LOCALE,
  payload: data
})

export const LocaleActions = {
  CHANGE_LOCALE: 'CHANGE_LOCALE'
}
